<template>
  <div class="manufacturerslist-container">
    <div class="search-layout">
      <el-form :model="queryInfo" size="medium" label-width="90px">
        <el-col :span="8">
          <el-form-item :label="$t('manage.name65')" prop="status">
            <el-select v-model="queryInfo.parentId" :placeholder="$t('public.name1')" @change="getTenantList" clearable>
              <el-option v-for="item in manufacturerNameOptions" :key="item.tenantId" :label="item.tenantName" :value="item.tenantId"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('manage.name86')" prop="loginName">
            <el-input v-model="queryInfo.tenantName" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('manage.name2')" prop="status">
            <el-select v-model="queryInfo.status" :placeholder="$t('public.name1')" style="width:130px;" @change="getTenantList">
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form>
      <div>
        <el-button type="primary" size="medium" @click="getPageList" v-if="buttonPerms.indexOf('tenant/list') > -1">{{ $t('public.name3') }}</el-button>
        <el-button size="medium" @click="resetQueryInfo">{{ $t('public.name4') }}</el-button>
      </div>
    </div>
    <div class="add-user">
      <el-button type="primary" icon="el-icon-plus" size="medium" @click="addVendor(null)" v-if="buttonPerms.indexOf('tenant/add') > -1">{{ $t('manage.name74') }}</el-button>
    </div>
    <el-table :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading">
      <el-table-column :label="$t('manage.name67')" prop="parentName" sortable></el-table-column>
      <el-table-column :label="$t('manage.name79')" prop="tenantName" sortable></el-table-column>
      <el-table-column :label="$t('manage.name68')" prop="createTime" sortable></el-table-column>
      <el-table-column :label="$t('manage.name80')" prop="tenantType" sortable>
        <template slot-scope="scope">
          <div v-if="scope.row.tenantType === 20">{{ $t('manage.name120') }}</div>
          <div v-if="scope.row.tenantType === 21">{{ $t('manage.name121') }}</div>
          <div v-if="scope.row.tenantType === 22">{{ $t('manage.name129') }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name92')" prop="merchantNum" sortable>
        <template slot-scope="scope">
          <div class="click-pointer" @click="cellClick(1, scope.row)">{{ scope.row.merchantNum }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name70')" prop="modelNum" sortable>
        <template slot-scope="scope">
          <div class="click-pointer" @click="cellClick(2, scope.row)">{{ scope.row.modelNum }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name82')" prop="remark"></el-table-column>
      <el-table-column :label="$t('manage.name83')" prop="status" sortable>
        <template slot-scope="scope">
          <el-switch :value="scope.row.status" active-color="#0f73e6" inactive-color="#dcdfe6" @change="changeSwitch(scope.row, $event)"> </el-switch>
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name130')" prop="address">
        <template slot-scope="scope">
         <div>{{ scope.row.address }}{{ scope.row.houseNumber }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name131')" prop="contactNumber"></el-table-column>
      <el-table-column :label="$t('manage.name15')" width="188px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="goMerchantUserList(scope.row)">{{ $t('manage.name84') }}</el-button>
          <el-button type="text" @click="addVendor(scope.row)" v-if="buttonPerms.indexOf('tenant/edit') > -1">{{ $t('manage.name17') }}</el-button>
          <el-button type="text" @click="delVendor(scope.row)" v-if="buttonPerms.indexOf('tenant/delete') > -1" style="color:#ea4646">{{ $t('manage.name18') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <el-dialog :title="$t('manage.name85')" v-if="merchantInfoDialog" :visible.sync="merchantInfoDialog" :close-on-click-modal ="false" :before-close="close" width="60%">
      <el-form ref="merchantFormRef" :model="merchantInfo" :rules="merchantInfoRules" label-width="100px" style="width:100%;" >
        <el-form-item prop="parentId" :label="$t('manage.name65')">
          <el-select v-model="merchantInfo.parentId" :placeholder="$t('public.name1')" style="width:100%;"  :disabled="merchantInfo.tenantId ? true : false">
            <el-option v-for="item in manufacturerNameOptions" :key="item.tenantId" :label="item.tenantName" :value="item.tenantId"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="tenantName" :label="$t('manage.name86')">
          <el-input v-model="merchantInfo.tenantName" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>
        <el-form-item prop="tenantType" :label="$t('manage.name87')">
          <el-select v-model="merchantInfo.tenantType" :placeholder="$t('public.name1')" style="width:100%;">
            <el-option v-for="item in merchantTypeOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="address" :label="$t('manage.name132')">
          <div v-html="detailsAddress"></div>
          <el-input v-model="merchantInfo.houseNumber" :placeholder="$t('manage.name134')"></el-input>
        </el-form-item>
        <el-form-item>
          <MapComponets></MapComponets>
        </el-form-item>
        <el-form-item prop="contactNumber" :label="$t('manage.name133')">
          <el-input v-model="merchantInfo.contactNumber" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>
        <el-form-item prop="remark" :label="$t('manage.name78')">
          <el-input v-model="merchantInfo.remark" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>

        <el-form-item prop="status" :label="$t('manage.name2')">
          <el-switch v-model="merchantInfo.status" active-color="#0f73e6" inactive-color="#dcdfe6"> </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" :loading="loading">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { tenantList, tenantAdd, tenantEdit, tenantDelete, tenantStatus } from '@/api/manage.js'
import MapComponets from './mapComponets.vue'
import coordtransform from 'coordtransform'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['userinfo'])
  },
  components: {
    MapComponets
  },
  data() {
    return {
      tableLoading: false,
      loading: false,
      detailsAddress: '',
      queryInfo: {
        page: 1,
        limit: 10,
        status: 2,
        parentId: '',
        tenantName: ''
      },
      tableList: [],
      statusOptions: [
        {
          value: 2,
          label: this.$t('operate.name98')
        },
        {
          value: 0,
          label: this.$t('operate.name48')
        },
        {
          value: 1,
          label: this.$t('operate.name39')
        }
      ],
      merchantTypeOptions: [
        {
          value: 20,
          label: this.$t('manage.name120')
        },
        {
          value: 21,
          label: this.$t('manage.name121')
        },
        {
          value: 22,
          label: this.$t('manage.name129')
        }
      ],
      total: 0,
      selectList: [],
      merchantInfoRules: {
        parentId: [
          {
            required: true,
            message: this.$t('bike.name476'),
            trigger: 'blur'
          }
        ],
        tenantName: [
          {
            required: true,
            message: this.$t('screen.name30'),
            trigger: 'blur'
          }
        ],
        address: [
          {
            required: true,
            message: this.$t('screen.name31'),
            trigger: 'blur'
          }
        ],
        contactNumber: [
          {
            required: true,
            message: this.$t('screen.name27'),
            trigger: 'blur'
          }
        ],
        tenantType: [
          {
            required: true,
            message: this.$t('screen.name32'),
            trigger: 'blur'
          }
        ]
      },
      merchantInfo: {
        parentId: '',
        tenantId: '',
        tenantName: '',
        tenantType: 20,
        address: '',
        province: '',
        city: '',
        region: '',
        lng: '',
        lat: '',
        contactNumber: '',
        remark: '',
        status: true
      },
      manufacturerNameOptions: [],
      merchantInfoDialog: false,
      buttonPerms: ''
    }
  },
  created() {
    this.buttonPerms = localStorage.getItem('buttonPerms')
    this.getManufacturerNameList()
    this.$bus.$on('addressInfo', (addressInfo) => {
      this.detailsAddress = addressInfo.address
      this.merchantInfo.address = addressInfo.address
      this.merchantInfo.province = addressInfo.province
      this.merchantInfo.city = addressInfo.city
      this.merchantInfo.region = addressInfo.region
      this.merchantInfo.lng = addressInfo.lng
      this.merchantInfo.lat = addressInfo.lat
    })
  },
  mounted() {
    this.getTenantList()
  },
  beforeDestroy() {
    this.$bus.$off('addressInfo')
  },
  methods: {
    addVendor(row) {
      if (row !== null) {
        const bikepointbaidu = coordtransform.wgs84togcj02(row.lng, row.lat)
        const bikepointsbaidu = coordtransform.gcj02tobd09(bikepointbaidu[0], bikepointbaidu[1])
        this.merchantInfo = {
          tenantName: row.tenantName,
          parentId: row.parentId,
          tenantId: row.tenantId,
          tenantType: row.tenantType,
          remark: row.remark,
          status: row.status,
          province: row.province,
          city: row.city,
          region: row.region,
          address: row.address,
          houseNumber: row.houseNumber,
          lng: Number(bikepointsbaidu[0]),
          lat: Number(bikepointsbaidu[1]),
          contactNumber: row.contactNumber
        }
        this.detailsAddress = row.address
      } else {
        this.merchantInfo.parentId = this.queryInfo.parentId
      }
      this.merchantInfoDialog = true
      // this.getManufacturerNameList()
      // const data = {
      //   page: 1,
      //   limit: 500,
      //   tenantType: 1
      // }

      // tenantList(data)
      //   .then(res => {
      //     this.manufacturerNameOptions = res.data.list
      //     if (this.userinfo.tenantType === 1) {
      //       this.queryInfo.parentId = this.manufacturerNameOptions[0].tenantId
      //     } else {
      //       this.merchantInfo.parentId = this.queryInfo.parentId
      //     }
      //     // if (row !== null) {
      //     //   this.merchantInfo.parentId = row.parentId
      //     // } else {
      //     //   this.merchantInfo.parentId = this.manufacturerNameOptions[0].tenantId
      //     // }
      //   })
      //   .catch(() => {
      //     this.manufacturerNameOptions = []
      //   })
    },

    close() {
      this.merchantInfoDialog = false
      this.merchantInfo = {
        parentId: '',
        tenantName: '',
        tenantId: '',
        tenantType: 20,
        address: '',
        houseNumber: '',
        province: '',
        city: '',
        region: '',
        lng: '',
        lat: '',
        contactNumber: '',
        remark: '',
        status: true
      }
      this.detailsAddress = ''
    },
    submitForm() {
      this.$refs.merchantFormRef.validate(async valid => {
        if (!valid) return
        this.loading = true
        if (this.merchantInfo.tenantId === '') {
          tenantAdd(this.merchantInfo)
            .then(res => {
              this.loading = false
              if (res.code === 200) {
                this.close()
                this.getTenantList()
              }
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          tenantEdit(this.merchantInfo)
            .then(res => {
              this.loading = false
              if (res.code === 200) {
                this.close()
                this.getTenantList()
              }
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    },

    resetQueryInfo() {
      this.queryInfo = {
        page: 1,
        limit: 10,
        status: 2,
        parentId: '',
        tenantName: ''
      }
      this.getTenantList()
    },
    getPageList() {
      this.queryInfo.page = 1
      this.queryInfo.limit = 10
      this.getTenantList()
    },
    getTenantList() {
      this.tableLoading = true
      const data = {
        page: this.queryInfo.page,
        limit: this.queryInfo.limit,
        tenantType: 2
      }

      if (this.queryInfo.tenantName) {
        data.tenantName = this.queryInfo.tenantName.trim()
      }

      if (this.queryInfo.parentId) {
        data.parentId = this.queryInfo.parentId
      }

      if (this.queryInfo.status !== 2) {
        if (this.queryInfo.status === 0) {
          data.status = true
        } else {
          data.status = false
        }
      }

      tenantList(data)
        .then(res => {
          this.tableList = res.data.list
          this.total = res.data.total
          this.tableLoading = false
        })
        .catch(() => {
          this.tableList = []
          this.total = 0
          this.tableLoading = false
        })
    },

    getManufacturerNameList() {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }

      tenantList(data)
        .then(res => {
          this.manufacturerNameOptions = res.data.list
          if (this.userinfo.tenantType === 1) {
            this.queryInfo.parentId = this.manufacturerNameOptions[0].tenantId
          } else {
            this.merchantInfo.parentId = this.queryInfo.parentId
          }
        })
        .catch(() => {
          this.manufacturerNameOptions = []
        })
    },

    delVendor(row) {
      this.$confirm(this.$t('screen.name16'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          tenantDelete({ tenantId: row.tenantId })
            .then(res => {
              this.loading = false
              if (res.code === 200) {
                this.close()
                this.getTenantList()
              }
            })
            .catch(() => {
              this.loading = false
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.name31')
          })
        })
    },
    changeSwitch(row, e) {
      const tip = row.status ? this.$t('screen.name33') : this.$t('screen.name34')
      this.$confirm(tip, this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          this.tableLoading = true
          tenantStatus({ tenantId: row.tenantId })
            .then((res) => {
              this.tableLoading = false
              this.getTenantList()
            })
            .catch(() => {
              this.tableLoading = false
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.name34')
          })
        })
    },
    cellClick(type, row) {
      console.log('row==', row)
      if (type === 1) {
      }

      if (type === 2) {
      }
    },
    // 监听pagesizes的事件
    handleSizeChange(newSize) {
      this.queryInfo.limit = newSize
      this.getTenantList()
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage
      this.getTenantList()
    },
    goMerchantUserList(row) {
      this.$router.push({ path: '/merchantuserlist', query: { tenantId: row.tenantId, parentId: row.parentId } })
    }
  }
}
</script>
<style lang="scss" scoped>
.manufacturerslist-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  .search-layout {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .click-pointer {
    cursor: pointer;
  }

  .qiyong {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #ebf6ed;
    color: #39ab4c;

    .text:before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 2px;
      background: #39ab4c;
      margin-right: 5px;
    }
  }

  .jinyong {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #fcecec;
    color: #ea4646;

    .text:before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 2px;
      background: #ea4646;
      margin-right: 5px;
    }
  }
}
</style>
